'use client'

import { createContext, useContext } from 'react'

export type FaqConfigContextType = {
  enableFaq: boolean
}

export const FaqConfigContext = createContext<FaqConfigContextType | undefined>(undefined)

export function useFaqConfigContext(): FaqConfigContextType {
  const context = useContext(FaqConfigContext)

  if (!context) {
    throw new Error('useFaqConfigContext must be used within a FaqConfigProvider')
  }

  return context
}

export function FaqConfigProvider({
  children,
  value,
}: {
  children: React.ReactNode
  value: FaqConfigContextType
}): React.ReactElement {
  return <FaqConfigContext.Provider value={value}>{children}</FaqConfigContext.Provider>
}
